/**
 * デバウンス関数
 * 高頻度で発火する関数呼び出しを指定時間遅延させる
 */
// biome-ignore lint/suspicious/noExplicitAny: Generic utility function requires flexible type constraint for function signatures
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return (...args: Parameters<T>) => {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
}
